import React, { useState, useEffect } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@material-ui/styles";
import PropTypes from "prop-types";

const StyledSnackbar = styled(Snackbar)(({ theme }) => ({
  "&.MuiSnackbar-root": {},
  "&.MuiSnackbar-anchorOriginBottomLeft": {},
  "& .MuiSnackbarContent-root": {
    backgroundColor: "#fff",
    color: "#121212",
  },
}));

const MAX_STR_LEN = 100;

const NotifyBasic = ({ open, message, type, duration, snackbarProps }) => {
  // props

  // local state
  const [localOpen, setLocalOpen] = useState(false);

  useEffect(() => {
    setLocalOpen(open);
  }, [open]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setLocalOpen(false);
  };

  const action = (
    <>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </>
  );
  const shortStr = (str) => {
    if (!str) return "";
    if (str.length > MAX_STR_LEN)
      return `${JSON.stringify(str).substring(0, MAX_STR_LEN)}...`;
    return JSON.stringify(str).substring(0, MAX_STR_LEN);
  };

  if (type) {
    return (
      <div>
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          open={localOpen}
          autoHideDuration={duration}
          onClose={handleClose}
          action={action}
          {...snackbarProps}
        >
          <Alert severity={type} color={type}>
            <Typography variant="body1">{shortStr(message)}</Typography>
          </Alert>
        </Snackbar>
      </div>
    );
  }

  return (
    <div>
      <StyledSnackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        open={localOpen}
        autoHideDuration={duration}
        onClose={handleClose}
        message={message}
        action={action}
        {...snackbarProps}
      />
    </div>
  );
};

NotifyBasic.propTypes = {
  open: PropTypes.bool,
  duration: PropTypes.number,
  message: PropTypes.string,
  type: PropTypes.string,
  snackbarProps: PropTypes.objectOf(PropTypes.any),
};

NotifyBasic.defaultProps = {
  open: false,
  duration: 5000,
  message: "",
  type: "",
  snackbarProps: {},
};

export default NotifyBasic;
